import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HisBackendService, DynamicComponent } from 'hisng';

@Injectable()
export class DynamicContentService {

    constructor( private backendService: HisBackendService ) { }

    /* generate dynamic content for a new entity */
    generateDynamicContent( targetName: string, requestParam?: string ): Observable<DynamicComponent> {
        if ( requestParam ) {
            return this.backendService.getData( `api/v1/fs/res/${targetName}/dynamicContent/generate?${requestParam}` );
        } else {
            return this.backendService.getData( `api/v1/fs/res/${targetName}/dynamicContent/generate` );
        }
    }
}
